import { AppState } from '../index';

/**
 * @function isModalOpenSelector
 * @param modalState
 */
export const isModalOpenSelector = ({ modalState }: AppState): boolean => modalState?.isModalOpen;
